import React from 'react';
import Layout from './components/Layout/Layout';
import PdfCompressionModal from './components/PdfCompressionModal';
import Providers from './components/Providers';
import CollabClient from './collab/CollabClient';
import UndoHistoryClient from './undo/UndoHistoryClient';
import SectionLoadingBanner from './collab/SectionLoadingBanner';
import ConfiguratorBanner from './collab/ConfiguratorBanner';
import HiddenDocumentBanner from './components/Layout/HiddenDocumentBanner';
import RestoreOverlay from './collab/RestoreOverlay';
import SessionRevokedOverlay from './collab/SessionRevokedOverlay';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { QueryClientProvider } from 'react-query';
import { ConfigProvider, Modal } from 'antd';
import frFR from 'antd/locale/fr_FR';
import { useStore } from './store/store';
import { queryClient } from './queryClient';
import './proposalApp.css';
import RecursiveModelSelectionModal from './components/RightSide/RecursiveModelSelectionModal';

const selector = (state) => ({
  loaderPdfToImage: state.loaderPdfToImage,
})

const ProposalApp = () => {
  const { loaderPdfToImage } = useStore(selector);

  return (
    // Taille de police par défaut des composants antd (bouton, input, select,
    // modal, table...) : token dédié, distinct de la cascade CSS body (index.less)
    // que antd ne suit pas nativement (cf. NavbarSelector.jsx). Les overrides
    // locaux (ex: NavbarSelector fontSize prop) restent prioritaires : un
    // ConfigProvider imbriqué gagne sur celui-ci pour ce qu'il précise.
    // locale : sans elle, les textes intégrés d'antd restaient en anglais
    // (« No data » des listes vides, etc.) ; l'éditeur est en français (i18n.js).
    <ConfigProvider theme={{ token: { fontSize: 11 } }} locale={frFR}>
      <QueryClientProvider client={queryClient}>
        <Modal
          open={loaderPdfToImage}
          footer={null}
          closable={false}
          centered
          width={400}
          mask
          styles={{
            mask: { backgroundColor: 'rgba(0, 0, 0, 0.45)' },
          }}
          wrapClassName="transparent-modal"
        >
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '40px 30px',
            minHeight: '200px',
            justifyContent: 'center',
            backgroundColor: 'transparent',
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%'
            }}>
              <img
                src={require('./images/Smart4Loader.gif')}
                alt="Loading"
                style={{ width: '150px', height: 'auto' }}
              />
            </div>
          </div>
        </Modal>
        <RecursiveModelSelectionModal />
        <PdfCompressionModal />
        <Providers />
        <CollabClient />
        <UndoHistoryClient />
        <SectionLoadingBanner />
        <ConfiguratorBanner />
        <HiddenDocumentBanner />
        <RestoreOverlay />
        <SessionRevokedOverlay />
        <DndProvider backend={HTML5Backend}>
          <Layout />
        </DndProvider>
      </QueryClientProvider>
    </ConfigProvider>
  );
}

export default ProposalApp;
